export const TIMEFORMAT = 'HH:mm';
export const DATEFORMAT2 = "DD/MM/YYYY";
export const DATEFORMAT3 = "DD-MM-YYYY";
